module.exports = __webpack_public_path__ + "static/media/02_van_on.b2279ae5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/street/02_van_on.png
// module id = 455
// module chunks = 0